// extracted by mini-css-extract-plugin
module.exports = {"StatusHeader":"StatusHeader_StatusHeader__3z1cj","ativo":"StatusHeader_ativo__3Ijfx","inativo":"StatusHeader_inativo__3Hz5V"};